import { AIButtonIconFlat as AIButtonIconFlatButton } from '../../AIButton'
import { BUTTON_HEIGHT_24, BUTTON_HEIGHT_32 } from '../../Button'
import { Container } from '../Container'

import PlusIcon from '../../../icons/plus.svg'

const AI_ICON_FLAT_SIZES = [BUTTON_HEIGHT_32, BUTTON_HEIGHT_24]

export function AIButtonIconFlat() {
  return (
    <>
      <Container label='AI Button, icon flat, sizes - 32px, 24px'>
        {AI_ICON_FLAT_SIZES.map(size => (
          <AIButtonIconFlatButton Icon={PlusIcon} height={size} key={size} />
        ))}
      </Container>
      <Container label='AI Button, icon flat, disabled, sizes - 32px, 24px'>
        {AI_ICON_FLAT_SIZES.map(size => (
          <AIButtonIconFlatButton
            disabled
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, icon flat, with loader, sizes - 32px, 24px'>
        {AI_ICON_FLAT_SIZES.map(size => (
          <AIButtonIconFlatButton
            isLoading
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, icon flat, with skeleton, sizes - 32px, 24px'>
        {AI_ICON_FLAT_SIZES.map(size => (
          <AIButtonIconFlatButton
            isSkeleton
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
